import React, { TdHTMLAttributes, TableHTMLAttributes, PropsWithChildren } from 'react'

type TableProps = TableHTMLAttributes<HTMLTableElement> & {
  ref?: React.Ref<HTMLTableElement>
}

type BodyProps = TdHTMLAttributes<HTMLTableCellElement> & {
  ref?: React.Ref<HTMLTableCellElement>
}

function Table({ children, ref, ...props }: PropsWithChildren<TableProps>) {
  return (
    <table
      ref={ref}
      role="presentation"
      cellPadding="0"
      cellSpacing="0"
      width="100%"
      border={0}
      align="center"
      {...props}
    >
      {children}
    </table>
  )
}

function Body({ children, ref, ...props }: PropsWithChildren<BodyProps>) {
  return (
    <tbody>
      <tr>
        <td ref={ref} {...props}>
          {children}
        </td>
      </tr>
    </tbody>
  )
}

function ContentWrapper({ children, ...props }: PropsWithChildren<BodyProps>) {
  return (
    <Table>
      <Body {...props}>{children}</Body>
    </Table>
  )
}

ContentWrapper.Table = Table
ContentWrapper.Body = Body

export default ContentWrapper
